import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCjoiIjIlA67QIVVQRS4WkT3bkn3QIQzzI",
  authDomain: "spurnest-website.firebaseapp.com",
  projectId: "spurnest-website",
  storageBucket: "spurnest-website.firebasestorage.app",
  messagingSenderId: "132661999924",
  appId: "1:132661999924:web:90c743aa4123d467b80d61",
  measurementId: "G-DEHY173FPP",
};

const app = initializeApp(firebaseConfig);

// Analytics only runs in the browser (not during SSR / build)
let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then((yes) => {
    if (yes) analytics = getAnalytics(app);
  });
}

export { app, analytics };
export default app;
